import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo, useEffect } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { AcquisitionSystemData } from 'shell/models/practice-lists';
import { ItemVM } from 'shell/view-models/item';
import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';

interface ListTypeInitiativeProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const ListTypeInitiativeComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
}: ListTypeInitiativeProps): React.ReactElement => {
  const [list, getList] = useHttpFetch<HttpResponseList<AcquisitionSystemData>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/pratiche/dominio-pratiche`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<AcquisitionSystemData>>) => {
        const { data } = response;
        return data?.payload.list?.map((item) => ({
          id: item.key?.codiceDominioPratica || '',
          value: item.testoValore || '',
        }));
      },
    }
  );

  const tipoPratica = 1;

  useEffect(() => {
    const data = {
      tipoDominioPratica: { value: tipoPratica, operation: Operation.EQUALS },
    };

    const queryParams = `${paginationListToQueryString({
      filters: data,
      orders: {},
    })}`;

    getList({
      params: {},
      paramsSerializer: () => queryParams,
    });
  }, [tipoPratica]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id="type-label">
        {required ? 'Tipo Iniziativa *' : 'Tipo Iniziativa'}
      </InputLabel>
      <PmiSelect
        labelId="type-label"
        id="type-Initiative"
        name="type-Initiative"
        value={value}
        label={required ? 'Tipo Iniziativa *' : 'Tipo Iniziativa '}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(list.data as Array<ItemVM>)?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTypeInitiativeComponent.displayName = 'List type component';

const ListTypeInitiative = memo(ListTypeInitiativeComponent);

export default ListTypeInitiative as typeof ListTypeInitiativeComponent;
